/**
 * Clamps a numeric value between a minimum and maximum range.
 *
 * @param {number|string} value - The value to clamp
 * @param {number} min - The minimum value (default: 0)
 * @param {number} max - The maximum value (default: 100)
 * @returns {number} The clamped value, or min if value is not a number
 *
 * @example
 * clampValue(150, 0, 100) // returns 100
 * clampValue(-10, 0, 100) // returns 0
 * clampValue(50, 0, 100)  // returns 50
 * clampValue("abc", 0, 100) // returns 0
 */
export const clampValue = (value, min = 0, max = 100) => {
  const numeric = Number(value);
  if (Number.isNaN(numeric)) return min;
  return Math.min(Math.max(numeric, min), max);
};

/**
 * Checks if a value can be converted to a valid number.
 *
 * @param {*} value - The value to check
 * @returns {boolean} True if the value is numeric, false otherwise
 *
 * @example
 * isNumericValue(42)      // returns true
 * isNumericValue("42")    // returns true
 * isNumericValue("42.5")  // returns true
 * isNumericValue("abc")   // returns false
 * isNumericValue(null)    // returns false
 * isNumericValue(undefined) // returns false
 */
export const isNumericValue = (value) => {
  const numeric = Number(value);
  return !Number.isNaN(numeric);
};
